







import Vue from "vue";
import Modal from "../../shared/modal/Modal.vue";
import { Component } from "vue-property-decorator";
import PickupsSearch from "./PickupsSearch.vue";

@Component({
  components: {
    MbeModal: Modal,
    PickupsSearch: PickupsSearch
  }
})
export default class PickupsList extends Vue {}
